import React from "react";
import { useParams } from "react-router-dom";

const blogData = [
  {
    id: 1,
    slug: "why-pincode-partners-retailers-join-lifeonplus",
    title:
      "Why Pin Code Partners and Retailers Should Join LifeOnPlus – The Future of Digital Health",
    date: "14th July 2026",
    heroImage: "/blogs/1.jpg",

    description: `Healthcare is no longer just about hospitals and clinics. It's about access, affordability, and preventive care delivered through digital technology.

LifeOnPlus is at the forefront of this transformation with its Global Digital Health Smart Card — and you now have the opportunity to be part of this revolution as a Channel Partner.`,

    sections: [
      {
        title: "What is the Global Digital Health Smart Card?",
        content: `The Smart Card is a one-stop healthcare solution that gives individuals and families:
• Anytime, Anywhere Access to health records
• Emergency Medical Data that can be retrieved instantly by doctors
• Discounted Healthcare Services – diagnostics, consultations, therapies, and wellness
• Preventive Care through AI-driven alerts and non-invasive health tests
• Affordable Plans starting from just ₹200/year
• Global Reach – use it across LifeOnPlus partner hospitals, labs, and clinics worldwide.`,
      },
      {
        title: "Why Partner with LifeOnPlus?",
        content: `LifeOnPlus is building India's largest preventive healthcare network, and partners play a key role.`,
      },
      {
        title: "Key Benefits",
        isList: true,
        content: [
          "High Margins & Earnings",
          "Recurring & Passive Income",
          "Exclusive Territory Rights",
          "Zero Inventory Risk",
          "Weekly Settlements & Transparency",
          "Training & Marketing Support",
        ],
      },
      {
        title: "Who Can Become a Partner?",
        content: `• Retailer (Metro Investment ₹15,000 | Non-Metro ₹5,000)\n• Pin Code Partner (Metro Investment ₹2.5 Lakh | Non-Metro ₹25,000)`,
      },
      {
        title: "How to Join",
        content: `1. Choose your role – Retailer or Pin Code Partner.\n2. Fill out the Enrolment Form.\n3. Make the enrolment payment.\n4. Receive your Partner Code & Dashboard login.\n5. Start selling & earning immediately.`,
      },
    ],
  },
  {
    id: 2,
    slug: "national-nutrition-week-2025",
    title:
      "National Nutrition Week (September 1–7): Nourishing India, One Plate at a Time",
    date: "September 1-7, 2025",
    heroImage: "/blogs/2.jpg",

    description: `Every year, September 1-7 is celebrated as National Nutrition Week in India. The goal is simple yet powerful — to create awareness about the importance of nutrition, balanced diets, and healthy lifestyles for a stronger, healthier nation.

At LifeOnPlus, we believe that good nutrition is the foundation of good health. Whether it’s preventing lifestyle diseases, boosting immunity, or improving energy levels, nutrition plays a vital role in every stage of life.`,

    sections: [
      {
        title: "Why Nutrition Matters",
        content: `Stronger Immunity: A nutrient-rich diet protects against infections and chronic illnesses.
Child Growth & Development: Proper nutrition ensures healthy physical and cognitive growth.
Productivity & Energy: A well-balanced diet keeps the body active and mind sharp.
Disease Prevention: Good food habits reduce risks of diabetes, hypertension, obesity, and heart disease.`,
      },
      {
        title: "Theme of National Nutrition Week 2025",
        content: `Each year, National Nutrition Week is celebrated around a theme set by the Ministry of Women and Child Development (WCD) and Food & Nutrition Board.

The theme for National Nutrition Week 2025 in India is "Healthy Diet, Healthy Life". This theme emphasizes the importance of nutritious food for overall well-being and aims to promote awareness about healthy eating habits and prevent malnutrition.`,
      },
      {
        title: "How You Can Celebrate National Nutrition Week with LifeOnPlus",
        content: `1. Track Your Nutrition: Use LifeOnPlus health tools to monitor BMI, skin carotenoids, and other nutrition indicators.
2. Adopt Smart Eating: Choose seasonal fruits, whole grains, and locally grown foods over processed snacks.
3. Hydration is Key: Aim for 8-10 glasses of water daily to maintain balance.
4. Small Steps Count: Replace fried snacks with sprouts, sugary drinks with lemon water, and fast food with home-cooked meals.
5. Community Engagement: Participate in awareness drives, share healthy recipes, and encourage family members to join the journey of wellness.`,
      },
      {
        title: "LifeOnPlus Contribution",
        content: `Through our Global Digital Health Smart Card and Body Recharge Stations, we aim to make preventive healthcare and wellness accessible to everyone. Nutrition is the first line of defense for health — and we are committed to helping people make informed, sustainable food choices.`,
      },
      {
        title: "Takeaway",
        content: `This National Nutrition Week, let’s pledge to:
1. Eat mindfully
2. Avoid food waste
3. Encourage healthier habits in our communities

Because when we nourish ourselves, we nourish the nation.`,
      },
    ],
  },
  {
    id: 3,
    slug: "your-health-your-right-government-benefits",
    title:
      "Your Health, Your Right: Unlocking Government Benefits Every Indian Should Know",
    date: "Compiled - LifeOnPlus 20.8.2025",
    heroImage: "/blogs/3.jpg",

    description: `Good health is the foundation of a strong nation. The Government of India has rolled out several initiatives to safeguard the health of its citizens — from free medical care to nutritional support, disease prevention, and digital healthcare access. Unfortunately, many people don’t know what is already available to them. Here’s a guide to the most important schemes and how you can access them.`,

    sections: [
      {
        title: "1. Ayushman Bharat – Pradhan Mantri Jan Arogya Yojana (PMJAY)",
        content: `Healthcare Coverage & Insurance
Eligibility: Poor and vulnerable families (as per SECC database).
Coverage: ₹5 lakh per family per year for hospital care (cashless).
How to Apply: Visit https://pmjay.gov.in or call 14555 / 1800-111-565.`,
      },
      {
        title: "2. State Health Insurance Schemes",
        content: `Example: Arogya Karnataka, Mukhya Mantri Chiranjeevi Yojana (Rajasthan).
How to Apply: Check respective state health portals.`,
      },
      {
        title: "Maternal & Child Health",
        content: `1. Janani Suraksha Yojana (JSY) – Financial aid for mothers delivering in government hospitals.
2. Janani Shishu Suraksha Karyakram (JSSK) – Free delivery, C-section, medicines, diagnostics, diet & transport.
3. Rashtriya Bal Swasthya Karyakram (RBSK) – Free health checkups for children (0-18 yrs).`,
      },
      {
        title: "Preventive Health & Immunization",
        content: `1. Universal Immunization Programme (UIP) – Free vaccines for children against 12 diseases.
2. Pulse Polio – Free polio drops for children under 5.
3. Health & Wellness Centres (HWCs) – Free medicines, diagnostics, yoga, and wellness services.`,
      },
      {
        title: "Nutrition & Wellness",
        content: `1. Poshan Abhiyaan – Nutritional support for women & children through Anganwadi centres.
2. Mid-Day Meal Scheme – Free nutritious meals for school children.`,
      },
      {
        title: "Disease Control Programs",
        content: `1. National Vector-Borne Disease Control Programme (NVBDCP)
2. National TB Elimination Programme (NTEP)`,
      },
      {
        title: "How to Avail these Benefits?",
        content: `• Ayushman Bharat – PM Jan Arogya Yojana (PMJAY)
• Enrolment / How to Apply
• Claim Process
• Steps at Hospital
• Includes pre- and post-hospitalization costs.`,
      },
    ],
  },
  {
    id: 4,
    slug: "international-left-handers-day",
    title: "August 13: International Left-Handers Day",
    date: "August 13",
    heroImage: "/blogs/4.jpg",

    description: `Celebrating the Unique 10% – The Left-Handed Community
Published by LifeOnPlus | Awareness & Inclusivity Series`,

    sections: [
      {
        title: "Left-Handers: A Minority with a Mighty Identity",
        content: `Did you know that only about 10% of the global population is left-handed?

International Left-Handers Day, observed on August 13th, is a celebration of individuality, creativity, and the neurodiversity of left-handed people around the world.

At LifeOnPlus, we believe that understanding biological diversity — including how the brain and body function differently — is key to both inclusive healthcare and educational empowerment.`,
      },
      {
        title: "How to Recognize a Left-Handed Child Early",
        content: `1. Prefers using the left hand for drawing or eating
2. Signs in early childhood (1-4 years)
3. Turns pages with left hand or uses left hand to reach for objects
4. Struggles with right-hand tasks like scissors or right-oriented school tools
5. Uses the left foot to kick or lead during activities

Left-handedness is determined by brain hemisphere dominance — typically right-brain dominant.`,
      },
      {
        title: "How Left-Handers May Behave or Function Differently",
        content: `While most left-handers function just like right-handers, studies have found:
1. Higher creativity and abstract thinking (often seen in arts, music, architecture)
2. Strong spatial and visual memory
3. More likely to adapt to change, due to navigating right-handed systems
4. Higher representation in certain fields: sports (especially tennis, boxing), arts, leadership`,
      },
      {
        title: "Left is Right Too – Myths vs Facts About Left-Handers",
        content: `Myth ❌ Reality
Left-handers are unlucky or cursed ❌ False – Left-handers are neurologically different, not “less”
They are more prone to mental illness ❌ Outdated – No proven link in modern research
They can’t write well ❌ They just need left-friendly tools and posture adjustments
Left-handedness can be corrected ❌ Forcing handedness can lead to speech or learning delays
Left-handers are more creative ✅ Many lefties excel in creative fields, possibly due to brain dominance`,
      },
      {
        title: "Medical & Educational Considerations",
        content: `1. Ergonomics & Tools: Ensure they use left-friendly notebooks, scissors, and keyboards
2. Posture Support: Train teachers to guide them properly while writing to avoid hand strain
3. No Force Conversion: Forcing right-handed writing can cause stress, anxiety, or stammering`,
      },
      {
        title: "LifeOnPlus Perspective: Personalized Understanding",
        content: `At LifeOnPlus, we advocate for recognizing neurodiversity early. With the help of:
1. Digital health screening (neuro-motor analysis, coordination tracking)
2. Child development reports
3. AI-driven learning pattern analysis

…we help educators, parents, and doctors embrace differences rather than correct them.`,
      },
      {
        title: "Final Thought",
        content: `Being left-handed is not a flaw — it’s a variation of normal. This August 13th, let’s celebrate the uniqueness, bust the myths, and build an inclusive world where every hand — right or left — is held with equal respect.`,
      },
    ],
  },
  {
    id: 5,
    slug: "world-lung-cancer-day",
    title: "World Lung Cancer Day – Let’s Breathe Better, Together",
    date: "August 1st",
    heroImage: "/blogs/5.jpg",

    description: `Every year on August 1st, the world comes together to recognize World Lung Cancer Day — a vital reminder of the need for awareness, early detection, and lifestyle changes that can save lives.

At LifeOnPlus, we believe in the power of preventive healthcare, and lung health is at the core of that vision.`,

    sections: [
      {
        title: "Why World Lung Cancer Day Matters?",
        content: `1. Lung cancer is the leading cause of cancer deaths globally.
2. It affects both smokers and non-smokers.
3. Early-stage lung cancer often has no symptoms, which makes awareness and screening critical.
4. Most cases are diagnosed at advanced stages, reducing treatment success rates.`,
      },
      {
        title: "Know the Symptoms",
        content: `Lung cancer doesn’t always present obvious symptoms early. However, be alert to:
1. Persistent cough (especially if worsening)
2. Chest pain
3. Shortness of breath
4. Coughing up blood
5. Hoarseness
6. Sudden weight loss
7. Recurrent respiratory infections`,
      },
      {
        title: "Risk Factors You Shouldn’t Ignore",
        content: `1. Smoking (even second-hand)
2. Air pollution & industrial exposure
3. Family history of cancer
4. Indoor pollutants (such as cooking smoke or radon gas)
5. Past radiation therapy to the chest`,
      },
      {
        title: "Prevention & Early Detection with LifeOnPlus",
        content: `At LifeOnPlus, we support lung health with:
• Non-invasive screenings
• Express health check-ups
• Air pollution risk assessments
• Remote consultations with lung specialists
• Digital Vaults for medical history and reports
• QR-based Smart Health Cards that share your health alerts in emergencies`,
      },
      {
        title: "Final Words",
        content: `This World Lung Cancer Day, let’s raise our voices for those who can’t — and take steps to protect our lungs, our lives, and our loved ones.

Breathe Strong. Live Long.`,
      },
    ],
  },
  {
    id: 6,
    slug: "world-humanitarian-day",
    title: "World Humanitarian Day – August 19th",
    date: "August 19th",
    heroImage: "/blogs/6.jpg",

    description: `On August 19th, the world commemorates World Humanitarian Day, a global tribute to those who risk their lives to help others in times of crisis. It’s a day to recognize humanity, compassion, and solidarity, especially in healthcare, disaster zones, and underserved regions.

At LifeOnPlus, we believe healthcare is not just a service — it’s a human right. Our mission goes beyond technology. It’s about connecting people to life-saving help, when and where they need it the most.`,

    sections: [
      {
        title: "Why This Day Matters",
        content: `World Humanitarian Day marks the anniversary of the 2003 bombing of the UN headquarters in Baghdad, which claimed the lives of 22 humanitarian workers. Since then, it has become a global movement to:
1. Honor frontline workers
2. Promote universal access to aid and healthcare
3. Encourage global citizens to take action
4. Advocate for health equity and dignity for all`,
      },
      {
        title: "Health as a Humanitarian Cause",
        content: `Health is the foundation of human dignity. Yet millions lack access to:
1. Basic medicine and diagnostics
2. Emergency response in rural or remote areas
3. Trained healthcare providers
4. Digitally connected health systems`,
      },
      {
        title: "This Year’s Global Message",
        content: `"Strengthening global solidarity and empowering local communities"

Whether it’s war, disaster, pandemic, or poverty — humanitarians step up, no matter what. At LifeOnPlus, we strive to be part of that chain — using digital tools to reach the unreached and protect lives with compassion and innovation.`,
      },
      {
        title: "How You Can Be a Health Humanitarian",
        content: `1. Help someone register for a LifeOnPlus Smart Card
2. Volunteer in a local health awareness drive
3. Sponsor or donate a health package for someone in need
4. Spread awareness about organ & eye donation
5. Educate others about the emergency features in QR-based health tools`,
      },
      {
        title: "Final Word",
        content: `Technology is powerful.

But when technology meets humanity, it becomes transformational.

This World Humanitarian Day, let’s recommit ourselves to building a more caring, connected, and healthier world — where no one is left behind.`,
      },
    ],
  },
  // Add more blog posts here
];

const BlogDetail = () => {
  const { id } = useParams();
  console.log(id);
  const blog = blogData.find((b) => b.id == id);

  if (!blog) {
    return (
      <div className="text-center py-20">
        <h2 className="text-3xl font-bold text-red-600">Blog Post Not Found</h2>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {/* Title */}
      <h1 className="text-3xl md:text-4xl font-bold text-center text-green-700 leading-tight">
        {blog.title}
      </h1>

      {/* Date */}
      <p className="text-center text-gray-500 mt-4 mb-12">{blog.date}</p>

      {/* Hero Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
        {/* Left */}
        <div>
          <div className="text-gray-700 text-lg leading-9 whitespace-pre-line text-justify">
            {blog.description}
          </div>
        </div>

        {/* Right */}
        <div className="flex justify-center lg:justify-end">
          <img
            src={blog.heroImage}
            alt={blog.title}
            className="w-full max-w-lg object-contain"
            style={{ marginTop: "-50px" }}
          />
        </div>
      </div>

      {/* Sections */}
      <div className="mt-16 space-y-14">
        {blog.sections?.map((section, index) => (
          <section key={index}>
            <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-6">
              {section.title}
            </h2>

            {section.isList ? (
              <ul className="list-disc pl-6 space-y-3 text-lg text-gray-700 leading-8">
                {section.content.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            ) : (
              <div className="text-lg text-gray-700 leading-9 whitespace-pre-line text-justify">
                {section.content}
              </div>
            )}
          </section>
        ))}
      </div>
    </div>
  );
};

export default BlogDetail;
